export const MarkupIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 6.66992C11 6.11764 10.5506 5.66348 10.0026 5.73234C8.77376 5.88675 7.59275 6.32505 6.55544 7.01816C5.23985 7.89722 4.21446 9.14665 3.60896 10.6085C3.00346 12.0703 2.84504 13.6788 3.15372 15.2306C3.4624 16.7825 4.22433 18.208 5.34315 19.3268C6.46197 20.4456 7.88743 21.2075 9.43928 21.5162C10.9911 21.8249 12.5997 21.6665 14.0615 21.061C15.5233 20.4555 16.7727 19.4301 17.6518 18.1145C18.3449 17.0772 18.7832 15.8962 18.9376 14.6673C19.0064 14.1194 18.5523 13.6699 18 13.6699H12.5C11.6716 13.6699 11 12.9983 11 12.1699V6.66992Z"
        stroke="#525866"
        strokeWidth="1.5"
      />
      <path
        d="M14 4.66992C14 4.11764 14.45 3.6626 14.9966 3.74123C15.5731 3.82415 16.1383 3.97888 16.6788 4.20277C17.5281 4.55455 18.2997 5.07016 18.9497 5.72017C19.5998 6.37019 20.1154 7.14186 20.4672 7.99114C20.691 8.53163 20.8458 9.09682 20.9287 9.67331C21.0073 10.22 20.5523 10.6699 20 10.6699L15 10.6699C14.4477 10.6699 14 10.2222 14 9.66992V4.66992Z"
        stroke="#525866"
        strokeWidth="1.5"
      />
    </svg>
  );
};
